import { Button as ButtonAtd } from "antd";
// export const Button = ButtonAtd;

export const Button = ButtonAtd
